import Sponsors from "components/sponsors";
import React from "react";
import { Link } from "react-router-dom";
import PWAPrompt from "react-ios-pwa-prompt";
import ga4 from "react-ga4";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation();
  return (
    <div className="home text-center d-flex align-items-center justify-content-center flex-column w-100">
      <img
        src={require("img/logo_full.png")}
        alt="iCyclin"
        height="auto"
        width="100%"
        className="mb-1 mt-lg-5"
        style={{ maxWidth: "500px" }}
      />
      <h6 className="text-muted mt-2 mt-lg-3 mb-3 mb-lg-5">
        {t(
          "auto.homeSubtitle",
          "Análise de Interações Medicamentosas em iCDK4/6",
        )}
      </h6>

      <div className="d-flex justify-content-center mt-3 flex-column flex-lg-row">
        <div className="me-lg-2 mb-3 w-md-100">
          <Link to="/private/search">
            <div className="card-pink d-flex justify-content-center flex-row flex-lg-column">
              <img
                src={require("img/icons/Icone_Interacoes_Farmaco.png")}
                alt=""
              />
              {t("auto.interacoesPorFarmaco", "Interações por fármaco")}
            </div>
          </Link>
        </div>
        <div className="mx-lg-2 mb-3">
          <Link to="/private/groups">
            <div className="card-pink d-flex justify-content-center flex-row flex-lg-column">
              <img
                src={require("img/icons/Icone_Grupos_Farmacologicos.png")}
                alt=""
              />
              {t("auto.gruposFarmacologicos", "Grupos Farmacológicos")}
            </div>
          </Link>
        </div>
        <div className="ms-lg-2 mb-3">
          <Link to="/private/patient">
            <div className="card-pink d-flex justify-content-center flex-row flex-lg-column">
              <img src={require("img/icons/Icone_Perfil_Doente.png")} alt="" />
              {t("auto.perfilDe", "Perfil de")}
              <br className="d-none d-lg-inline" />
              {t("auto.doente", "Doente")}
            </div>
          </Link>
        </div>
      </div>
      <Sponsors />

      <PWAPrompt
        timesToShow="5"
        copyTitle="Instale a app iCyclin"
        copyBody="Adicione esta aplicação ao seu ecrã principal para a poder encontrar rapidamente, utilizar mesmo que esteja sem rede e usar o ecrã inteiro, tal como uma app descarregada da AppStore."
        delay="2000"
        onClose={(e) => {
          console.log("User closed iOS install prompt");
          ga4.event({
            category: "app-interaction",
            action: "app-prompt-close",
            label: "ios prompt closed",
          });
        }}
        copyShareButtonLabel="Toque em 'Partilhar' no menu abaixo"
        copyAddHomeButtonLabel="Selecione 'Adicionar ao ecrã principal'"
        copyClosePrompt="Cancelar"
      ></PWAPrompt>
    </div>
  );
};

export default Home;
